<template>
  <v-popup @close="$emit('close')">
    <div class="free-contingent-used-popup">
      <p class="free-contingent-used-popup__text-top">
        {{ $t("page.order.submit.freecontingent.popup.used.header.start") }}
        <strong>{{ $t("page.order.submit.freecontingent.popup.used.header.bold") }}</strong>
        {{ $t("page.order.submit.freecontingent.popup.used.header.end") }}
      </p>
      <p class="free-contingent-used-popup__text-bottom">
        {{ $t("page.order.submit.freecontingent.popup.used.description") }}
      </p>
      <div class="free-contingent-used-popup__buttons">
        <v-button white @click="$emit('close')">
          <img src="~@/assets/icons/icon-cancel.svg" class="icon-left" />
          {{ $t("common.cancel") }}
        </v-button>
        <v-button primary @click="$emit('confirm')">
          <img src="~@/assets/icons/icon-trash.svg" class="icon-left" />
          {{ $t("common.continue") }}
        </v-button>
      </div>
    </div>
  </v-popup>
</template>

<script>
import { VPopup, VButton } from "shared";
export default {
  name: "VFreeContingentUsedPopup",
  components: {
    VPopup,
    VButton
  }
};
</script>

<style lang="scss" scoped>
::v-deep .popup {
  &__container {
    min-width: 0;
    padding: 48px 75px 45px;
    width: 443px;
  }
}
.free-contingent-used-popup {
  text-align: center;
  &__img {
    margin: 0 0 35px 0;
  }
  &__text-top {
    margin: 0 auto 16px;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #333333;
    max-width: 255px;
  }
  &__text-bottom {
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.464286px;
    color: #333333;
    max-width: 293px;
    margin: 0 auto;
  }
  &__buttons {
    margin: 24px 0 0 0;
    display: flex;
    justify-content: center;
    .button {
      margin: 0 5px;
      padding: 11px 20px 11px 35px;
    }
  }
}
</style>
